<template>
    <div>
        <standard-form v-if="this.id == 43"
            v-bind:parentObject = "{
                data: this.item,
                id: this.id,
                parameter: this.parameter,
                errMsg: this.errMsg,
            }"
            
            v-on:input="formData = $event"
        />

        <div v-if="isErr">
            <app-error 
                v-bind:parentError = "{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
                v-on:closeError="isErr = $event"
            />
        </div>   
    </div>
</template>

<script>
import StandardForm from '../../../components/payroll/glexport/StandardForm';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'standard-form': StandardForm,
        'app-error': ErrorDialog
    },

    data() {
        return{
            item: this.$route.params.item,
            id: this.$route.params.id,
            parameter: this.$route.params.parameter,
            
            errMsg: '',
            isErr: false,
        }
    },

}

</script>